import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChartDonut = () => {
  return (
    <g>
      <path d="m14.8538 11.9136a7.84 7.84 0 0 0 0-7.8271c-.0059-.0115-.0054-.0244-.012-.0357-.0082-.0142-.0222-.022-.0312-.0353a7.9476 7.9476 0 0 0 -2.8259-2.826c-.0134-.009-.0212-.023-.0355-.0312-.0113-.0065-.0241-.0061-.0356-.012a7.8988 7.8988 0 1 0 2.9037 10.8273c.0065-.01.0184-.0138.0245-.0243s.0061-.0242.012-.0357zm-6.1538-7.9287v-2.4456a6.44 6.44 0 0 1 1.9222.5181l-1.2233 2.1192a4.0331 4.0331 0 0 0 -.6989-.1917zm-.7 1.3295a2.6855 2.6855 0 1 1 -2.6856 2.6856 2.689 2.689 0 0 1 2.6856-2.6856zm3.8234 1.2866 2.1193-1.2235a6.4482 6.4482 0 0 1 0 5.2448l-2.1194-1.2231a3.8586 3.8586 0 0 0 0-2.7982zm1.4148-2.4334-2.12 1.2238a4.09 4.09 0 0 0 -.51-.51l1.2238-2.12a6.546 6.546 0 0 1 1.4062 1.4063zm-5.2382 10.3324a6.4992 6.4992 0 0 1 -.7-12.9607v2.4456a4.0789 4.0789 0 1 0 3.8184 6.6238l2.12 1.2236a6.4887 6.4887 0 0 1 -5.2384 2.6677z" />
    </g>
  );
};

export default withIcon(IconChartDonut);
